export function initMetaPixel() {
  try {
    if (typeof window === 'undefined') return
    if ((window as any).fbq) return

    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    ;(window as any).fbq = n
    ;(window as any)._fbq = n

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
    ;(window as any).fbq('init', '1438495414738821')
    ;(window as any).fbq('track', 'PageView')
  } catch (e) {
    // Silently fail if pixel cannot be loaded
  }
}

export function trackAddToCart() {
  try {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;(window as any).fbq('track', 'AddToCart')
    }
  } catch (e) {
    // Silently fail
  }
}
